<template>
  <div class="bothbox">
    <section>
      <article>
        <a href="javascript:;" class="add" @click="chosePhoto()"> <img id="imCon"  src="../../../static/img/addcon.png"alt=""></a>
        <div class="btnCon" >
          <div class="btnCon1">
            <a href="javascript:;" @click="income()">主营业务收入</a>
            <a href="javascript:;" >其他业务收入</a>
            <a href="javascript:;" @click="nonincome()">营业外收入</a>
            <a href="javascript:;" @click="investincom()">投资收益</a>
            <a href="javascript:;" @click="fincom()">查询与编辑收入记录</a>
          </div>
          <div class="inCon">
            <li class="inCon1">
              <p>其他业务收入</p>
              <input  id="icon1" type="text" placeholder="请输入金额"  v-model="Amount">
            </li>
            <li class="inCon3">
              <p>客户</p>
              <p>
                <input id="icon2" type="text" placeholder="请输入客户" v-model="Log" @click="toCus" readonly>
                <vue-pickers
                  :show="isshow"
                  :columns="columns"
                  :selectData="customercon"
                  @cancel="close1"
                  @confirm="concus">
                </vue-pickers>
              </p>
            </li>
            <li class="inCon2">
              <p>收入确认日期</p>
              <p >
                <input class="js-startdate-picker" type="text" placeholder="请输入日期" v-model="AffirmDate" readonly>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon2">
              <p>收款截止日期</p>
              <p>
                <input class="js-enddate-picker" type="text" placeholder="请输入日期" v-model="Datec" readonly>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon2">
              <p>货币</p>
              <p>
                <input type="text" placeholder="请选择货币" id="btncon2" @click="toCurry" v-model="Currency" readonly>
                <vue-pickers
                  :show="isshow2"
                  :columns="columns"
                  :selectData="currencyCon"
                  @cancel="close3"
                  @confirm="currycon">
                </vue-pickers>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon3">
              <p>税种</p>
              <p>
                <input id="cafees" type="text" placeholder="请选择税种" @click="toShow" v-model="TaxationType" readonly>
                <vue-pickers
                  :show="show"
                  :columns="columns"
                  :selectData="cafeesCon"
                  @cancel="close"
                  @confirm="catfeesCon">
                </vue-pickers>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon2">
              <p>收款方式</p>
              <p>
                <input type="text" placeholder="请输入收款方式" v-model="RPType" id="rptype" @click="toRPType" readonly>
                <vue-pickers
                  :show="isshow4"
                  :columns="columns"
                  :selectData="RPTypeconlist"
                  @cancel="close4"
                  @confirm="RPTypecon">
                </vue-pickers>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon2">
              <p>收款子类</p>
              <p>
                <input type="text" placeholder="请选择收款子类"  v-model="subcategory" id="sub" @click="tosub" readonly>
                <vue-pickers
                  :show="isshow5"
                  :columns="columns"
                  :selectData="subcacon"
                  @cancel="close5"
                  @confirm="subcatecon">
                </vue-pickers>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon3">
              <p>收入类别</p>
              <p>
                <input id="chose" type="text" placeholder="请选择收入类型" v-model="InvType" readonly>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon3">
              <p>业务单元</p>
              <p>
                <input type="text" placeholder="请选择业务单元" v-model="Business_GUID" readonly>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>

            <li class="inCon3">
              <p>业务子单元</p>
              <p>
                <input type="text" placeholder="请选择业务子单元" v-model="SubBusiness_GUID" readonly>
                <a href="javascript:;">
                  <img src="../../../static/img/xjiant.png" alt="">
                </a>
              </p>
            </li>
            <li class="inCon3">
              <p>税费金额</p>
              <p>
                <input type="text" placeholder="请输入税费金额" v-model="TaxationAmount" readonly>
              </p>
            </li>
            <li class="inCon3">
              <p>含税总金额</p>
              <p>
                <input type="text" placeholder="请输入含税总金额" v-model="SumAmount" readonly>
              </p>
            </li>
            <li class="inCon3">
              <p>摘要备注</p>
              <p>
                <input id="icon5" type="text" placeholder="请输入摘要备注" v-model="Remark">
              </p>
            </li>
            <li class="inCon3">
              <p>合同/发票/凭证号</p>
              <p>
                <input id="icon6" type="text" placeholder="请输入" v-model="InvNo">
              </p>
            </li>
          </div>
        </div>
      </article>
    </section>
    <footer>
      <a href="javascript:;" @click="Save">提交</a>
      <a href="javascript:;">返回</a>
    </footer>

  </div>
</template>

<script>
  import vuePickers from 'vue-pickers'
  export default {
    name: "otherincom",
    components: {
      vuePickers
    },
    data() {
      return {
        subcategory:'',
        isshow5:false,
        subcatelist:[],
        subcacon:{
          data1:[{
            text:'1111',
            value:'1111'
          }]
        },
        DetailInvtype: '',
        DetailInvtype1: '',
        DetailRPType: '',
        file: '',
        timeCon: '',
        nonce: '',
        sigin: '',
        ManCon: [],
        Business_GUID: '',
        Currency: '',
        Datec: '',
        AffirmDate: '',
        Amount: '',
        DC_GUID: '',
        InvNo: '',
        TaxationAmount: '',
        SumAmount: '',
        DisAmount: '',
        IE_GUID: '',
        InvType: '',
        Log: '',
        Log_c: '',
        RPType: '',
        RPer: '',
        Remark: '',
        State: '',
        SubBusiness_GUID: '',
        TaxationType: '',
        C_GUID: '',
        Creator: '',
        Name:'',
        chooseList:[],
        cafeesCon:{
          data1:[{
            text:'',
            value:''
          }]
        },
        catfeesList:[],
        customercon:{
          data1:[{
            text: '1111',
            value: '1111'
          }]
        },
        currencyList:[],
        currencyCon:{
          data1:[{
            text:'',
            value:''
          }]
        },
        customerList:['全部','其他'],
        isshow:false,
        show:false,
        isshow2:false,
        columns: 1,
        isshow4:false,
        RPTypeconlist:{
          data1:[
            {
              text:'1111',
              value:'1111'
            }
          ]
        },
        costLIst:[]
      }
    },
    mounted: function () {
      this.$axios.post('/fmsapi/common/GetSignatureInfo').then(res => {
        this.timeCon = res.data.result.timestamp,
          this.nonce = res.data.result.noncestr,
          this.sigin = res.data.result.signature
        this.$wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: 'wxcbf86100e1590700', // 必填，公众号的唯一标识
          timestamp: this.timeCon, // 必填，生成签名的时间戳
          nonceStr: this.nonce, // 必填，生成签名的随机串
          signature: this.sigin,// 必填，签名
          jsApiList: ['chooseImage', 'getLocalImgData'] // 必填，需要使用的JS接口列表
        });
      })
      this.BirthDateSelect()
      this.BirthEndDateSelect()
      this.GetCustomer()
      this.catfees()
      this.getcurrency()
      this.GetBankInfo();
      this.GetPayOrReceivablesType()
    },
    methods: {
      chosePhoto: function () {//点击事件选择图片
        var _this = this
        this.$wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            _this.imgid = res.localIds; // 返回选定照片的本地ID列表
            _this.$wx.getLocalImgData({
              localId: _this.imgid[0], // 图片的localID
              success: function (res) {
                this.file = res.localData; // localData是图片的base64数据，可以用img标签显
                if (this.file.indexOf('data:image') != 0) {
                  this.file = 'data:image/jpeg;base64,' + this.file
                }
                let data = new FormData();
                data.append('file', _this.dataURLtoBlob(this.file))
                data.append('frGuid', '96489F0A-B84F-4B51-A807-C8E0688024DE')
                data.append('TempFileNameFirst', '发票Post')
                data.append('Type', 'Ocr')
                _this.$axios.post('/fmsapi/common/FileUpload', data).then(res => {
                  _this.ManCon = JSON.parse(res.data.ImageOcr)
                  console.log(_this.ManCon.words_result)
                  _this.Amount = _this.ManCon.words_result.TotalAmount
                  _this.Log = _this.ManCon.words_result.PurchaserName
                  _this.AffirmDate = (_this.ManCon.words_result.InvoiceDate).replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, "");
                  _this.Datec = (_this.ManCon.words_result.InvoiceDate).replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, "");
                  _this.InvType = '其他业务收入'
                  _this.Remark = _this.ManCon.words_result.Remarks
                  _this.InvNo = _this.ManCon.words_result.SellerRegisterNum
                }).catch(error => {
                  alert(error)
                })
              }
            });
          }
        })

      },
      back() {
        this.$router.push({path: "/company"})
      },
      income(){
        this.$router.push({path:'/income'})
      },
      nonincome(){
        this.$router.push({path:'/nonincome'})
      },
      investincom(){
        this.$router.push({path:'/investincom'})
      },
      fincom(){
        this.$router.push('/findincom')
      },
      dataURLtoBlob(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type: mime});
      },
      /**
       ** 加法函数，用来得到精确的加法结果
       ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
       ** 调用：accAdd(arg1,arg2)
       ** 返回值：arg1加上arg2的精确结果
       **/
      accAdd(arg1, arg2) {
        if (!arg1) {
          arg1 = 0;
        }
        if (!arg2) {
          arg2 = 0;
        }
        arg1 = arg1.toString().replace(/\,/g, "");
        arg2 = arg2.toString().replace(/\,/g, "");

        var r1, r2, m, c;
        try {
          r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
          r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
          var cm = Math.pow(10, c);
          if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
          } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
          }
        } else {
          arg1 = Number(arg1.toString().replace(".", ""));
          arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
      },
      getcurrency(){
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res=>{
          this.currencyList=res.data.result
          this.currencyCon.data1=new Array();
          for(var i=0;i<this.currencyList.length;i++){
            this.currencyCon.data1.push({"text":this.currencyList[i].Code,"value":this.currencyList[i].Code})
          }
        })
      },
      Save() {
        let a = this.accAdd(this.TaxationAmount != '' ? this.TaxationAmount : 0, this.Amount != '' ? this.Amount : 0)
        this.costLIst=[{
          Business_GUID: '',
          Currency:this.Currency,
          Date: this.Datec !== '' ? this.Datec : alert('日期不能为空'),
          AffirmDate: this.AffirmDate,
          Amount: this.Amount,
          DC_GUID: '',
          InvNo: this.InvNo,
          TaxationAmount: this.TaxationAmount,
          SumAmount:this.SumAmount,
          DisAmount:a,
          IE_GUID: '',
          InvType: '其他业务收入',
          Log: this.Log,
          Log_c: '',
          RPType:this.RPType,
          RPer: sessionStorage.getItem('RPercon'),
          Remark: this.Remark,
          State:'' ,
          SubBusiness_GUID: '',
          TaxationType:sessionStorage.getItem('T_GUID'),
          C_GUID: sessionStorage.getItem('companyId'),
          Creator: sessionStorage.getItem('loginName'),
        }]
        let parm = JSON.stringify(this.costLIst)
        this.$axios.post('/fmsapi/IERecord/UpdateIncomeRecord', parm, {
          headers: {
            'Content-Type': 'application/json;'
          }
        }).then(res => {
          alert('提交成功')
          this.$router.push({path: "/home"})
        })
      },
      subcatecon(val){
        var sub=document.getElementById('sub')
        this.isshow5 = false
        sub.value=val.select1.value
        this.subcategory= sub.value
      },
      close5(){
        this.isshow5=false
      },
      tosub(val){
        if(this.RPType==='银行存款'){
          this.isshow5=true
        }else {
          this.isshow5=false
        }
      },
      choose(i){
        var i=i
        var chose=document.getElementById('chose')
        var list=document.getElementById('list')
        this.InvType=i.Name
        console.log(this.InvType)
        list.style.display='none'
        sessionStorage.setItem('chosevalue',this.InvType)
      },

      cafees(i){
        var i=i
        var catfees=document.getElementById('catfees')
        var cafees=document.getElementById('cafees')
        cafees.value=i.Name
        catfees.style.display='none'
        sessionStorage.setItem('cafees',cafees.value)
      },
      catfees(){
        var catfees=document.getElementById('catfees')
        this.$axios({
          method:'post',
          url:'/fmsapi/common/GetTaxListType',
          data:this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
          })
        }).then(res=>{
          this.catfeesList=res.data.result
          this.cafeesCon.data1=new Array();
          for(var i=0;i<this.catfeesList.length;i++){
            this.cafeesCon.data1.push({"text":this.catfeesList[i].Name,"value":this.catfeesList[i].Name,'T_GUID':this.catfeesList[i].T_GUID,'Rate':this.catfeesList[i].Rate})
          }
        })
      },

      BirthDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function() {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function() {
            /*取消时触发事件*/
          }
        });
      },
      BirthEndDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-enddate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function() {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function() {
            /*取消时触发事件*/
          }
        });
      },
      GetCustomer(i) {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetCustomer',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList=res.data.result
          // custormlog.style.display="block"
          this.customercon.data1=new Array();
          for(var i=0;i<this.customerList.length;i++){
            this.customercon.data1.push({"text":this.customerList[i].Name,"value":this.customerList[i].Name,'RPercon':this.customerList[i].BP_GUID})
          }
        })
      },
      GetBankInfo(){
        this.$axios({
          method:'post',
          url:'/fmsapi/common/GetBankInfo',
          data:this.$qs.stringify({
            cGuid:sessionStorage.getItem('companyId')
          })
        }).then(res=>{
          this.subcatelist=res.data
          this.subcacon.data1=new Array()
          console.log(this.subcatelist)
          for(var i=0;i<this.subcatelist.length;i++){
            this.subcacon.data1.push({'text':this.subcatelist[i].label,'value':this.subcatelist[i].label})
          }

        })
      },
      GetPayOrReceivablesType(){
        this.$axios({
          method:'post',
          url:'/fmsapi/common/GetPayOrReceivablesType',
          data:this.$qs.stringify({
            cGuid:sessionStorage.getItem('companyId')
          })
        }).then(res=>{
          this.RPTypeconcon=res.data
          this.RPTypeconlist.data1=new Array();
          console.log(res.data)
          for(var i=0;i<this.RPTypeconcon.length;i++){
            this.RPTypeconlist.data1.push({"text":this.RPTypeconcon[i].label,'value':this.RPTypeconcon[i].label,'payid':this.RPTypeconcon[i].value})
            console.log(this.RPTypeconcon[i])
          }
          console.log(res.data)
        })
      },

      currycon(val) {
        var btn3=document.getElementById('btncon2')
        this.isshow2 = false
        btn3.value=val.select1.value
        this.Currency=btn3.value
        // console.log(JSON.parse(this.defaultData))
      },
      concus(val) {
        var btn2=document.getElementById('icon2')
        console.log(val.select1.value)
        sessionStorage.setItem('RPercon',val.select1.RPercon)
        this.isshow = false
        btn2.value=val.select1.value
        this.Log = btn2.value
        console.log(this.Log)
        // console.log(JSON.parse(this.defaultData))
      },
      close1() {
        console.log(123)
        this.isshow = false
      },
      close3() {
        console.log(123)
        this.isshow2 = false
      },
      toCus(val) {
        this.isshow = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      toCurry(val) {
        this.isshow2 = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      catfeesCon(val) {
        var btn=document.getElementById('cafees')
        this.show = false
        btn.value=val.select1.value
        sessionStorage.setItem('T_GUID',val.select1.T_GUID)
        sessionStorage.setItem('catname',val.select1.value)
        sessionStorage.setItem('Rate',val.select1.Rate)
        this.TaxationType = btn.value
        console.log(this.TaxationType)
        if(sessionStorage.getItem('Rate')&&this.Amount!==''){
          var a=sessionStorage.getItem('Rate')
          this.TaxationAmount=parseFloat((this.Amount)/(1+a/100)*(a/100)).toFixed(2)
          this.SumAmount=parseFloat(this.Amount)
          this.Amount=parseFloat(this.SumAmount-this.TaxationAmount).toFixed(2)
        }else {
          this.TaxationType=''
          alert('请输入收入金额')
        }
        // console.log(JSON.parse(this.defaultData))
      },
      RPTypecon(val){
        var btn4=document.getElementById('rptype')
        console.log(val.select1.value)
        sessionStorage.setItem('payid',val.select1.payid)
        this.isshow4 = false
        btn4.value=val.select1.value
        this.RPType = btn4.value
      },
      close4() {
        console.log(123)
        this.isshow4 = false
      },
      toRPType(val){
        this.isshow4 = true
      },
      close() {
        console.log(123)
        this.show = false
      },
      toShow(val) {
        this.show = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
    }
  }
</script>

<style scoped>
  /*大盒子，首位固定*/
  #catfees{
    position: absolute;
    height: 9rem;
    right: 14px;
    top: 57px;
    z-index: 3;
    overflow: auto;
    display: none;
  }
  #catfees p{
    height: 2.5rem;
    background: beige;
    border-bottom: 1px solid black;
  }
  #catfees p:last-child{
    height: 2rem;
  }
  #list{
    height: 9rem;
    width: 12rem;
    position: absolute;
    display: none;
    right: 14px;
    top: 57px;
    z-index: 1;
  }
  #list p{
    height: 2rem;
    background: beige;
    border-bottom: 1px solid black;
  }
  #list p:last-child{
    height: 2rem;
    padding-left: 48px;
  }
  .bothbox{
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;
  }
  /*头部固定*/
  header{
    height: 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /*头部标题*/
  .head{
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1.3rem;
    color: black;
  }
  /*标题样式*/
  .head h2{
    display: block;
    width: 25rem;
    text-align: center;
  }
  .head img:last-child {
    width: 0.15rem;
    height: 0.11rem;
  }
  .head img:first-child{
    width: 0.09rem;
    height: 0.17rem;
  }
  /*中间部分*/
  section{
    flex:1;
    background: #f1f5f6;
    height: 100%;
    overflow: auto;
    position: relative;
  }
  .add img{
    width: 0.5rem;
    height: 0.5rem;
    position: fixed;
    bottom: 90px;
    right: 20px;
    z-index: 2;
  }
  .btnCon{
    height: 1.03rem;
    margin-top: 2px;
    padding: 0.07rem 0;
    background: white;
  }
  .btnCon1{
    height: 1.03rem;
    background: #f6f6f6;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

  }
  .btnCon1 a{
    display: block;
    width: 1.07rem;
    height: 0.32rem;
    background:white;
    border-radius: 8px;
    color: black;
    margin-left: 12px;
    text-align: center;
    line-height: 0.32rem;
  }
  .btnCon1 a:nth-child(2){
    background: #09a9bf;
    color: white;
  }
  .btnCon1 a:last-child{
    width: 1.37rem;
    height: 0.32rem;
  }
  .inCon{
    width: 100%;
    background: white;
    margin-top: 0.07rem;
  }
  .inCon1{
    height: 0.46rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
  }
  .inCon1 p{
    width: 1.21rem;
    height:100%;
    text-align: center;
    line-height: 0.46rem;
    font-size: 0.15rem;
    color: black;
  }
  .inCon1 input{
    display: block;
    width: 1.37rem;
    height: 0.46rem;
    font-size: 0.23rem;
    color: black;
    text-align:right ;
    margin-right: 23px;
  }
  .inCon2{
    height:0.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.19rem;
    border-bottom: 1px solid #f6f6f6;
  }
  .inCon2 p{
    font-size: 0.13rem;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .inCon2 p:last-child{
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .inCon2 input{
    display: block;
    font-size: 0.14rem;
    text-align: right;
  }
  .inCon2 img{
    width: 0.12rem;
    height: 0.07rem;
  }
  .inCon3{
    position: relative;
    height:0.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.19rem;
    border-bottom: 1px solid #f6f6f6;
  }
  .inCon3 p{
    font-size: 0.13rem;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .inCon3 p:last-child{
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .inCon3 input{
    display: block;
    height: 0.5rem;
    font-size: 0.14rem;
    color: black;
    text-align: right;
  }
  #icon2{
    width: 2.02rem;
    text-align: right;
  }
  .inCon3 img{
    width: 0.12rem;
    height: 0.07rem;
  }
  /*尾部*/
  footer{
    display: flex;
    height: 0.55rem;
    background: #ffffff;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  footer a{
    display: block;
    width: 1.55rem;
    height: 0.325rem;
    border-radius:29px;
    font-size: 0.12rem;
    text-align: center;
    line-height: 0.325rem;

  }
  footer a:first-child{
    background: #009bb4;
  }
  footer a:last-child{
    border: 1px solid #009bb4;
    color: #4c4c4c;
  }
</style>
